import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { RadioGroupWrapperOption } from "@webapp/shared/radio-group-wrapper/radio-group-wrapper.models";

/**
 * Needed because ui-radio-group uses @ContentChildren to get the radio options
 * and uses that array for the UP and DOWN arrow handlers - needed for the accessibility
 *
 * A downgraded Angular component can't use @ContentChildren as it always returns an empty array
 */
@Component({
  selector: "radio-group-wrapper",
  templateUrl: "./radio-group-wrapper.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioGroupWrapperComponent {
  @Input() public selected: unknown;
  @Input() public options: RadioGroupWrapperOption[];

  @Output() public readonly selectedChange = new EventEmitter<unknown>();

  public valueChange(value: unknown): void {
    this.selectedChange.emit(value);
  }
}
